import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { AiOutlineClose } from "react-icons/ai";

import {
  currencyList,
  languageList,
  customerZones,
} from "../constants/localization";
import countryToCurrency from "country-to-currency";
import Select, { components } from "react-select";

var country_df = "GB";
var language_df = navigator.language.toLowerCase().substring(0, 2);

const WelcomeBox = ({ setLocationConfirmed, locationConfirmed }) => {
  const [country, setCountry] = useState(country_df);
  const [language, setLanguage] = useState(language_df);
  const { t } = useTranslation();

  const updateCountry = (e) => {
    setCountry(e.target.value);
  };

  const updateLanguage = (e) => {
    setLanguage(e.target.value);
  };

  /*
  React.useEffect(() => {
    let user_prefs = {};
    let currency = countryToCurrency[country];
    if (currencyList[currency] === undefined) currency = "USD";
    user_prefs.currency = currencyList[currency];
    let zone;
    if (customerZones.UK.includes(country)) zone = "UK";
    else if (customerZones.EU.includes(country)) zone = "EU";
    else if (customerZones.US.includes(country)) zone = "US";
    else zone = "other";
    user_prefs.customer_zone = zone;
    user_prefs.language = language;
    localStorage.setItem("user-prefsv2", JSON.stringify(user_prefs));
  }, []);
  */

  const localeConfirmed = async () => {
    let user_prefs = {};

    //Set currency from country dropdown
    let currency = countryToCurrency[country];
    if (currencyList[currency] === undefined) currency = "USD";
    user_prefs.currency = currencyList[currency];

    //Set Customer Zone from country dropdown
    let zone;
    if (customerZones.UK.includes(country)) {
      zone = "UK";
    } else if (customerZones.EU.includes(country)) {
      zone = "EU";
    } else if (customerZones.US.includes(country)) {
      zone = "US";
    } else {
      zone = "other";
    }
    user_prefs.customer_zone = zone;

    //Get Language from dropdown selected language
    user_prefs.language = language;

    saveLocale(user_prefs);
  };

  const saveLocale = (user_prefs) => {
    localStorage.setItem("user-prefsv2", JSON.stringify(user_prefs));
    localStorage.setItem("i18nextLng", language);
    window.location.reload();
    setLocationConfirmed(true);
  };

  const countries = Object.keys(
    JSON.parse(t("localization.main.countries"))
  ).map((k) => ({
    value: JSON.parse(t("localization.main.countries"))[k],
    label: k,
  }));

  const languages = Object.keys(languageList).map((k) => ({
    label: languageList[k],
    value: k,
  }));

  const { Option, SingleValue } = components;
  const IconSingleValue = (props) => {
    console.log(props);
    const [image, setImage] = React.useState(
      `/assets/flags/${props.data.value}.webp`
    );
    return (
      <SingleValue {...props}>
        <div className="flex flex-row gap-2 items-center">
          <img
            className="w-6"
            onError={() => setImage("/assets/flags/unknown.svg")}
            src={image}
            alt={props.data.label}
          />
          {props.data.label}
        </div>
      </SingleValue>
    );
  };
  const IconOption = (props) => {
    const [image, setImage] = React.useState(
      `/assets/flags/${props.data.value}.webp`
    );
    return (
      <Option {...props}>
        <div className="flex flex-row gap-2 items-center">
          <img
            className="w-6"
            onError={() => setImage("/assets/flags/unknown.svg")}
            src={image}
            alt={props.data.label}
          />
          {props.data.label}
        </div>
      </Option>
    );
  };

  return (
    !locationConfirmed && (
      <div className="fixed top-0 left-0 w-full h-full flex items-end justify-center z-[1000] ">
        <div className=" w-3/4 md:w-1/2 rounded-md p-6 bg-[#F6F6F6] mb-8 border border-[#D1D1D1] relative">
          <div className="flex justify-end absolute top-1 right-1">
            <AiOutlineClose
              onClick={() => localeConfirmed()}
              className="w-5 h-5 text-red-500 cursor-pointer justify-end absolute"
            />
          </div>
          {/* <h2 className="text-2xl font-bold mb-4">{t("welcome.main.title")}</h2> */}
          <div className="flex flex-col lg:flex-row gap-4 items-end">
            <div className="flex-1 w-full lg:w-auto">
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="country"
              >
                {t("welcome.main.country")}
              </label>
              <Select
                onChange={(e) => setCountry(e.value)}
                options={countries}
                value={countries.find((c) => c.value === country)}
                components={{
                  Option: IconOption,
                  SingleValue: IconSingleValue,
                }}
                styles={{
                  indicatorSeparator: (style) => ({
                    ...style,
                    display: "none",
                  }),
                  control: (style) => ({
                    ...style,
                    border: "1px solid rgb(156 163 175)",
                  }),
                }}
              />
            </div>
            <div className="flex-1 w-full lg:w-auto">
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="language"
              >
                {t("welcome.main.language")}
              </label>
              <Select
                onChange={(e) => setLanguage(e.value)}
                options={languages}
                value={languages.find((c) => c.value === language)}
                styles={{
                  indicatorSeparator: (style) => ({
                    ...style,
                    display: "none",
                  }),
                  control: (style) => ({
                    ...style,
                    border: "1px solid rgb(156 163 175)",
                  }),
                }}
              />
            </div>
            <button
              className="bg-pr hover:bg-sr transition-all duration-300 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              type="button"
              onClick={() => localeConfirmed()}
            >
              {t("welcome.main.button")}
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default WelcomeBox;
